import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import getRenderable from '../../../../lib/getRenderable';
import { getProgressPercent } from '../helpers';
import { CIRCLE_MAX, BASE_CIRCLE_STYLE, PATH } from './constants';
import classes from './index.module.scss';

const getCircleStyle = (percent, fill) => {
    const progress = (CIRCLE_MAX * percent) / 100;
    const style = {
        ...BASE_CIRCLE_STYLE,
        strokeDashoffset: (CIRCLE_MAX - progress)
    };

    fill && Object.assign(style, {
        stroke: fill
    });

    return style;
};

const Round = ({
    percent,
    size,
    className: customClassName,
    progressClassName: customProgressClassName,
    backgroundClassName: customBackgroundClassName,
    fill,
    children
}) => {
    const progress = getProgressPercent(percent);
    const className = classnames(
        classes.progressbar,
        customClassName
    );
    const progressClassName = classnames(
        classes.progressFill,
        customProgressClassName
    );
    const backgroundClassName = classnames(
        classes.background,
        customBackgroundClassName
    );
    const backgroundStyle = {
        ...getCircleStyle(100)
    };
    const fillStyle = {
        ...getCircleStyle(progress, fill)
    };
    const style = {
        fontSize: `${size}px`,
        color: fill
    };

    return (
        <div className={className} style={style}>
            <svg viewBox="-1 -1 71 71">
                <path className={backgroundClassName} d={PATH} style={backgroundStyle}/>
                <path className={progressClassName} d={PATH} style={fillStyle}/>
            </svg>
            {children && <span className={classes.percentageLabel}>{ getRenderable(children) }</span>}
        </div>
    );
};

Round.propTypes = {
    percent: PropTypes.number.isRequired,
    className: PropTypes.string,
    progressClassName: PropTypes.string,
    backgroundClassName: PropTypes.string,
    fill: PropTypes.string,
    size: PropTypes.number,
    children: PropTypes.node
};

export default Round;
